export const TOAST_MESSAGE = {
    SESSION_INVITATION_COPIED: "session_invitation_copied",
    GUEST_URL_COPY: "guest_url_copy",
    OBSERVER_URL_COPIED: "observer_url_copied",
    SESSION_CODE_COPY: "session_code_copy",
    NOTE_DELETED_SUCCESSFULLY: "note_deleted_successfully",
    FAILED_DELETE_NOTE: "failed_delete_note",
    NOTE_ADDED_SUCCESSFULLY: "note_added_successfully",
    FAILED_ADD_NOTE: "failed_add_note",
    NOTE_EDITED_SUCCESSFULLY: "note_edited_successfully",
    FAILED_EDIT_NOTE: "failed_edit_note",
    LOCATION_IMAGE_UPLOAD_FAILED: "location_image_upload_failed",
};
